import React from 'react';
import { NavLink } from 'redux-first-router-link';
import './topbar.css';

import logo from '../../assets/images/logo.svg';

import { User } from 'react-feather';
import { Home } from 'react-feather';
import { Folder } from 'react-feather';
import { Calendar } from 'react-feather';
import { Camera } from 'react-feather';

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="top-left">
        <img src={logo} />
      </div>
      <NavLink to="/" exact={true} activeClassName="active">
        <Home />
        Home
      </NavLink>
      <NavLink to="/results" activeClassName="active">
        <Folder />
        Results
      </NavLink>
      <NavLink to="/booking" activeClassName="active">
        <Calendar />
        Booking
      </NavLink>
      <NavLink to="/profile" activeClassName="active">
        <User />
        Profile
      </NavLink>
      <NavLink to="/camera" activeClassName="active">
        <Camera />
        Camera
      </NavLink>

    </div>
  );
};

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar/index.js